
import { isProduction } from '@com/config/env';
import { mindworkURL } from '@/common/mindworkURL';
export default {
  data: function data() {
    return {
      previewURL: '',
      outputURL: '',
      orientation: 3,
      name: '',
      language: ['zh-cn'],
      env: isProduction ? 0 : 1 // test=[生产环境=0][测试环境/本地=1]
    };
  },


  components: {},
  methods: {
    onSubmit: function onSubmit() {
      this.outputURL = '';
      if (!this.previewURL) {
        this.$message.error('preview url is required');
        return;
      }
      this.outputURL = mindworkURL({
        url: this.previewURL,
        itavideo: 2,
        orientation: this.orientation,
        name: this.name,
        language: this.language.join(','),
        env: this.env,
        isHttp: false
      });
    }
  },
  computed: {
    orientationOptions: function orientationOptions() {
      return [{
        value: 1,
        label: 'Vertical（竖屏）'
      }, {
        value: 2,
        label: 'Horizontal（横屏）'
      }, {
        value: 3,
        label: 'Auto(自适应)'
      }];
    },
    languageList: function languageList() {
      return [{
        label: 'Chinese(zh-cn)',
        value: 'zh-cn'
      }, {
        label: 'English(en)',
        value: 'en'
      }, {
        label: 'Japanese(ja)',
        value: 'ja'
      }, {
        label: 'Korean(ko)',
        value: 'ko'
      }, {
        label: 'French(fr)',
        value: 'fr'
      }, {
        label: 'German(de)',
        value: 'de'
      }, {
        label: 'Italian(it)',
        value: 'it'
      }, {
        label: 'Spanish(es)',
        value: 'es'
      }, {
        label: 'Portuguese(pt)',
        value: 'pt'
      }, {
        label: 'Russian(ru)',
        value: 'ru'
      }];
    }
  },
  mounted: function mounted() {
    // this.$store.dispatch('config/getLanguagesList')
  }
};